export const WITH_APPOINTMENT_OPTIONS = [
  { value: 'true', label: 'With Appointment' },
  { value: 'false', label: 'Without Appointment' },
];

export const VIVA_OPTIONS = [
  { value: 'viva', label: 'Viva' },
  { value: 'not specified', label: 'Not Specified' },
];

export const STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const PRODUCT_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const OFFER_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const SOURCE_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const PRIORITY_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const ASSIGNEE_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];
export const UPDATE_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
];

export const STATUS_UPDATE_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'negotiation', label: 'Negotiation' },
  { value: 'closed_won', label: 'Closed Won' },
  { value: 'closed_lost', label: 'Closed Lost' },
];
export const PRIORITY_OPTION = [
  { id: 'none', label: 'None', bg: '#2B7FFF1A', border: '#2B7FFF', text: '#2D6CDF' },
  { id: 'high', label: 'High', bg: '#FFE2E2', border: '#FFA2A2', text: '#C10007' },
  { id: 'medium', label: 'Medium', bg: '#FEF3C6', border: '#FFD230', text: '#BB4D00' },
  { id: 'low', label: 'Low', bg: '#F1F5F9', border: '#CAD5E2', text: '#45556C' },
  { id: 'new', label: 'New', bg: '#2B7FFF1A', border: '#2B7FFF', text: '#2D6CDF' },
];
export const STATS = {
  totalLeads: 6500,
  totalConverted: 8900,
  totalValue: '678,878 AMD',
  conversionRate: '50%',
};
